<!-- 
mp3
 -->
<template>
  <div class="mp3-box">
    <top @envChange="envChange" />
    <mp3body
      ref="mp3widget"
      @stateChange="stateChange"
      v-if="mp3Show"
      :view="view"
      :audio="playResources"
    />
    <div class="controls">
      <div class="left-mp3">
        <a-icon
          type="backward"
          style="color: white;"
          @click="before(current - 1)"
        />
      </div>
      <div class="play-mp3">
        <a-icon
          type="play-circle"
          theme="twoTone"
          two-tone-color="#1890ff"
          @click="play"
          v-if="isPaused"
        />
        <a-icon
          type="pause-circle"
          style="color: white;"
          @click="pause"
          v-else
        />
      </div>
      <div class="next-mp3">
        <a-icon
          type="forward"
          style="color: white;"
          @click="next(current + 1)"
        />
      </div>
    </div>
    <div class="other-body">
      <div class="icon-list">
        <div class="icon-item">
          <a-icon type="like" />
          <p>{{ view.count.likeCount }}</p>
        </div>
        <div class="icon-item">
          <a-icon type="star" />
          <p>收藏</p>
        </div>
        <div class="icon-item">
          <a-icon type="share-alt" />
          <p>分享</p>
        </div>
      </div>
      <div class="select">
        <p class="select-title">/ 选集 /</p>
        <div class="video-select-list">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="video-select-box"
            :class="{ active: index === current }"
          >
            <div class="before1"></div>
            <div class="before2"></div>
            <div class="before3"></div>
            <p @click="change(index)">{{ index + 1 }}</p>
          </div>
        </div>
      </div>
      <div class="summary">
        <div class="title">
          <p>第{{ current + 1 }}集简介</p>
        </div>
        <div class="summary-text">
          <p>{{ list[current].summary || "暂无简介" }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mp3body from "./widget/mp3";
import top from "./top";
export default {
  name: "videoContent",
  components: {
    mp3body,
    top,
  },
  props: {
    view: {
      type: Object,
    },
  },
  data() {
    return {
      max: null,
      dTime: null,
      cTime: "00:00",
      done: false,
      time: 0,
      current: 0,
      isPaused: true,
      list: this.view.displayResources,
      img: require("@/assets/img/share/adown.png"),
      moveTime: {
        min: "00",
        sec: "00",
      },
      mp3Show: false,
      playResources: {},
    };
  },
  computed: {},
  mounted() {
    this.playResources = this.view?.displayResources[0];
    this.mp3Show = true;
    document.getElementsByTagName("title")[0].innerText = this.view.title;
  },
  methods: {
    play() {
      this.$refs.mp3widget.play();
    },
    pause() {
      this.$refs.mp3widget.pause();
    },
    chnageplay() {
      // this.pause()
      this.mp3Show = false;
      this.playResources = this.view?.displayResources[this.current];
      this.$nextTick(() => {
        this.mp3Show = true;
      });
      // this.play()
    },
    before(index) {
      if (index > -1 && index < this.list.length) {
        this.current = index;
        this.chnageplay();
        // this.$refs.mp3widget.next(this.list[index].sourceUrl);
        // this.$refs.mp3widget.setBakImgSrc(this.list[index].thumbUrl);
      }
    },
    next(index) {
      if (index && index < this.list.length) {
        this.current = index;
        this.chnageplay();
        // this.$refs.mp3widget.next(this.list[index].sourceUrl);
        // this.$refs.mp3widget.setBakImgSrc(this.list[index].thumbUrl);
      }
    },
    stateChange(e) {
      this.isPaused = e;
    },
    onChange(e) {
      console.log(e);
    },
    onAfterChange(e) {
      console.log(e);
    },
    tipFormatter(e) {
      const min = parseInt(e / 60);
      const sec = e % 60;
      const topStr = min.toString() + ":" + sec.toString();
      return topStr;
    },
    change(index) {
      if (index === this.current) {
        return;
      }
      this.current = index;
      this.chnageplay();

      if (this.list[index].sourceUrl) {
        this.next(this.current);
      }
    },
    envChange(e) {
      this.$emit("envChange", e);
    },
  },
};
</script>
<style>
@import "../../node_modules/ant-design-vue/dist/antd.css";
body {
  background-color: #242a38 !important;
}
</style>
<style lang="less" scoped>
/deep/ .ant-slider-handle {
  border: 0;
}
.mp3-box {
  background-color: #242a38;
}

.video-select-list {
  display: flex;
  display: -webkit-flex;
  overflow: auto;
  // margin-top: 20px;
  p {
    font-size: 16px;
    font-weight: bold;
  }
  .active {
    color: #1989fa;
    position: relative;
    background-color: #2c3f4e !important;
    .before1 {
      display: block;
      position: absolute;
      bottom: 0;
      left: 2px;
      height: 10px;
      width: 2px;
      background-color: #1989fa;
    }
    .before2 {
      display: block;
      position: absolute;
      bottom: 0;
      left: 5px;
      height: 6px;
      width: 2px;
      background-color: #1989fa;
    }
    .before3 {
      display: block;
      position: absolute;
      bottom: 0;
      left: 8px;
      height: 8px;
      width: 2px;
      background-color: #1989fa;
    }
  }
  .video-select-box {
    margin: 20px 10px 10px 10px;
    height: 40px;
    width: 40px;
    background-color: #31394b;
    border-radius: 5px;
    p {
      padding: 15px;
      text-align: center;
      padding-top: 10px;
    }
  }
}

.controls {
  display: flex;
  justify-content: center;
  div {
    margin: 0 30px;
  }
}
.other-body {
  .icon-list {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    font-size: 14px;
    .icon-item {
      color: #d9d9d9;
      display: flex;
      align-items: baseline;
      border: 1px solid #d9d9d9;
      border-radius: 14px;
      margin: 0 10px;
      padding: 0 15px;
      p {
        margin-bottom: 0;
        padding: 0 10px;
      }
    }
  }
  .select {
    .select-title {
      text-align: center;
      color: #fff;
      font-size: 18px;
    }
  }
  .summary {
    margin: 20px 0;
    p {
      font-size: 14px;
      color: #fff;
      margin-bottom: 0;
    }
    .title {
      font-size: 15px;
      text-align: center;
    }
    .summary-text {
      padding: 5px 10px;
    }
  }
}
/deep/ #topImg {
  background-color: #fff;
}
/deep/ .top-title {
  margin-bottom: 0;
}
</style>
